export enum SortUsersBy {
    byImage,
    byFullName
}
